import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ClearedRec14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_67)'>
      <path
        d='M6.50006 8.56066L10.5304 4.53033L9.46973 3.46967L6.50006 6.43934L5.03039 4.96967L3.96973 6.03033L6.50006 8.56066Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.5 0.25C0.815897 0.25 0.25 0.80024 0.25 1.49682V10.5018C0.25 11.1958 0.813255 11.75 1.5 11.75H3.25V12.5478C3.25 13.5551 4.38044 14.1487 5.20967 13.5768L7.85854 11.75H12.5C13.1904 11.75 13.75 11.1904 13.75 10.5V1.5C13.75 0.809644 13.1904 0.25 12.5 0.25H1.5ZM1.75 10.25V1.75H12.25V10.25H7.39146L4.75 12.0717V10.25H1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_67'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ClearedRec14.displayName = 'ClearedRec14';
export default ClearedRec14;
